import { useEffect, useRef } from 'react'
import { useTheme } from '@emotion/react'
import useIntersection from 'react-use/lib/useIntersection'
import { useAnimation } from 'framer-motion'

/**
 * Animation utility that utilizes the IntersectionObserver API"
 */
const useReveal = ({ ref, direction = 'up' }) => {
  const visible = useRef(false)

  const theme = useTheme()

  const intersection = useIntersection(ref, {
    rootMargin: '0px',
    threshold: 0.25,
  })

  const controls = useAnimation()

  useEffect(() => {
    if (intersection?.isIntersecting && !visible.current) {
      visible.current = true

      controls.start('visible')
    }
  }, [intersection, controls])

  return {
    variants: {
      hidden: {
        opacity: 0,
        y: direction === 'up' ? theme.space.large : -theme.space.large,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: theme.motion.timing.base,
        },
      },
    },
    controls,
  }
}

export default useReveal
